import {Fragment} from "react";
import classNames from "classnames";
import dynamic from "next/dynamic";
const FormattedText = dynamic(() => import("../../formatted-text").then((mod) => mod.FormattedText));

function TimelineTrack() {
  return (
    <div>
      <div className="h-full w-[2px] bg-primary relative">
        <div className="rounded-full bg-primary h-[10px] w-[10px] absolute top-[45px] -left-[4px]"/>
      </div>
    </div>
  )
}
export function ParagraphTimeline ({paragraph, ...props}) {
  const items = paragraph?.field_timeline_items?.filter(item => item?.type !== "unknown");
  const tlItems = paragraph?.field_tl_items?.filter(item => item?.type !== "unknown");
  if (!items?.length && !tlItems?.length) return <></>

  return (
    <>
      {tlItems?.length ? (
        <div className="paragraph--timeline grid gap-x-8 md:gap-x-12 grid-cols-timeline-sm md:grid-cols-timeline w-[90%] mx-auto">
          {tlItems.filter(item => item?.id).map((item, index) => {
            const right = index % 2 === 0;
            const left = !right;

            return (
              <Fragment key={`paragraph-timeline--tli-item--${paragraph.id}--${index}`}>
                <div className="max-md:contents md:hidden">
                  <TimelineTrack/>
                </div>
                {left && (
                  <div className="max-md:hidden contents">
                    <div/>
                    <TimelineTrack/>
                  </div>
                )}
                <div className={classNames("drop-shadow-sm rounded-md bg-white p-8 max-md:mb-12", {"md:text-right": right})}>
                  <div className="text-primary text-2xl">{item.field_tli_title}</div>
                  {item?.field_tli_body?.processed && (
                    <div>
                      <FormattedText processed={item.field_tli_body.processed}/>
                    </div>
                  )}
                </div>
                {right && (
                  <div className="max-md:hidden contents">
                    <TimelineTrack/>
                    <div/>
                  </div>
                )}
              </Fragment>
            )
          })}
        </div>
      ): <></>}
      {items?.length ? (
        <div className="paragraph--timeline grid gap-x-8 md:gap-x-12 grid-cols-timeline-sm md:grid-cols-timeline w-[90%] mx-auto">
          {items.filter(item => item?.id).map((item, index) => {
            const right = index % 2 === 0;
            const left = !right;

            return (
              <Fragment key={`paragraph-timeline--${paragraph.id}--${index}`}>
                <div className="max-md:contents md:hidden">
                  <TimelineTrack/>
                </div>
                {left && (
                  <div className="max-md:hidden contents">
                    <div/>
                    <TimelineTrack/>
                  </div>
                )}
                <div className={classNames("drop-shadow-sm rounded-md bg-white p-8 max-md:mb-12", {"md:text-right": right})}>
                  <div className="text-primary text-2xl">{item.title}</div>
                  {item?.body?.processed && (
                    <div>
                      <FormattedText processed={item.body.processed}/>
                    </div>
                  )}
                </div>
                {right && (
                  <div className="max-md:hidden contents">
                    <TimelineTrack/>
                    <div/>
                  </div>
                )}
              </Fragment>
            )
          })}
        </div>
      ): <></>}
    </>
  )
}